// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lp-3";
export var downloadButton = "_lp-4";
export var fileContainer = "_lp-9 _lp-7";
export var fileContainerBase = "_lp-7";
export var fileContainerFixedHeight = "_lp-8 _lp-7";
export var fileInfo = "_lp-5";
export var fileInfoWidthRestricted = "_lp-6";
export var fileType = "_lp-1";
export var fileTypeName = "_lp-2";
export var image = "_lp-0";
export var link = "_lp-b";
export var overflowEllipsis = "_lp-a";